import { jsx, Fragment, jsxs } from 'react/jsx-runtime';
import { useState, useCallback } from 'react';
import { styled, Menu, useTheme } from '@mui/material';
import { ReactComponent as ForwardRef } from '../../../assets/icons/ElipsisSmall.svg.js';
import Button from '../../Button/Button.js';
import '../../Button/SplitButton.js';
import RowMenuItems from './RowMenuItems.js';

const StyledMenu = styled(Menu)({ '& .MuiMenu-list': { padding: 0 } });
/**
 * Context menu of data grid row, including the triggering button
 */
const RowMenu = ({ options, ['data-testid']: testid }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const isMenuOpen = Boolean(anchorEl);
    const theme = useTheme();
    const onMenuOpen = useCallback((e) => {
        // Prevent triggering row expansion/collapse
        e.stopPropagation();
        setAnchorEl(e.currentTarget);
    }, []);
    const onMenuClose = useCallback((e) => {
        // Prevent triggering row expansion/collapse
        e.stopPropagation();
        setAnchorEl(null);
    }, []);
    const onKeyDown = useCallback((e) => {
        if (e.key === 'ArrowDown') {
            onMenuOpen(e);
        }
        else if (e.key === 'Enter' || e.key === ' ') {
            // Prevent triggering row expansion/collapse when opening the menu.
            // (No need to manually open the menu in this case, because the click event is activated by the browser.)
            e.stopPropagation();
        }
    }, [onMenuOpen]);
    if (options.display === 'inline') {
        return jsx(Fragment, { children: options.controls });
    }
    if (options.itemGroups.flatMap(group => group.items).length === 0) {
        return null;
    }
    return (jsxs("div", Object.assign({ "data-testid": testid }, { children: [jsx(Button, Object.assign({ size: "medium", variant: "text", onClick: onMenuOpen, onKeyDown: onKeyDown }, { children: jsx(ForwardRef, {}) })), jsx(StyledMenu, Object.assign({ open: isMenuOpen, "data-testid": "row-menu", onClose: onMenuClose, anchorReference: "anchorEl", anchorEl: anchorEl, dir: theme.direction }, { children: jsx(RowMenuItems, { itemGroups: options.itemGroups, onMenuClose: onMenuClose }) }))] })));
};

export { RowMenu as default };
//# sourceMappingURL=RowMenu.js.map
